/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReleaseNotesModel } from '../../models/release-notes-model';

export interface GetAllFeatureDetailsForSelectedYearInReleaseNotes$Params {
  year?: string;
}

export function getAllFeatureDetailsForSelectedYearInReleaseNotes(http: HttpClient, rootUrl: string, params?: GetAllFeatureDetailsForSelectedYearInReleaseNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReleaseNotesModel>>> {
  const rb = new RequestBuilder(rootUrl, getAllFeatureDetailsForSelectedYearInReleaseNotes.PATH, 'get');
  if (params) {
    rb.query('year', params.year, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReleaseNotesModel>>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getAllFeatureDetailsForSelectedYearInReleaseNotes.PATH = '/api/featuredetails/getallfeaturedetailsforselectedyearinreleasenotes';
getAllFeatureDetailsForSelectedYearInReleaseNotes.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getAllFeatureDetailsForSelectedYearInReleaseNotes.ROOTURL = '/portal';
